// src/components/payments/PaymentCancelled.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { usePageTitle } from '../../hooks/usePageTitle';
import './PaymentResult.css';

const PaymentCancelled = () => {
    usePageTitle('Payment Cancelled');
    const navigate = useNavigate();

    const handleRetryPayment = () => {
        navigate('/subscriptions');
    };

    const handleGoToDashboard = () => {
        navigate('/dashboard');
    };

    return (
        <div className="payment-result-container">
            <div className="payment-result-card cancelled">
                <div className="payment-result-icon">
                    <i className="fas fa-times-circle"></i>
                </div>
                <h1>Payment Cancelled</h1>
                <p className="payment-result-message">
                    Your payment was cancelled. No charges have been made to your account.
                </p>

                <div className="payment-result-info">
                    <h4>Why was my payment cancelled?</h4>
                    <ul>
                        <li>You clicked the cancel button during checkout</li>
                        <li>You closed the payment window</li>
                        <li>The payment session expired</li>
                    </ul>
                </div>

                <div className="payment-result-actions">
                    <button className="btn btn-primary" onClick={handleRetryPayment}>
                        <i className="fas fa-redo"></i>
                        Try Again
                    </button>
                    <button className="btn btn-secondary" onClick={handleGoToDashboard}>
                        <i className="fas fa-home"></i>
                        Go to Dashboard
                    </button>
                </div>

                <div className="payment-help">
                    <p>
                        <i className="fas fa-question-circle"></i>
                        Need help? Contact our support team at{' '}
                        <a href="mailto:support@ehaazri.com">support@ehaazri.com</a>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PaymentCancelled;
